export let results2021 = {
 categories: ["demographics","fun","drinking","medical","drug_Use"],
 charts: [{
    demographics: {
        How_long_have_you_been_reading_r_CA__Years_2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`0 (since 2021)`,`1 (since 2020)`,`2 (since 2019)`,`3 (since 2018)`,`4 (since 2017)`,`5 (since 2016)`,`6 (since 2015)`,`7 (since 2014)`,`8 (since 2013)`,`9 (since 2012)`,`10 (since 2011)`,`11 (since 2010)`],
                },
                title: {
                  text: "How long have you been reading r/CA? (Years)"
                },
                series: [
                  {
                    name: 'Count',
                    data: [316,331,284,187,107,94,51,43,33,25,14,21]
                  }
                ],
                legend: {
                  enabled: false
                },
              }
        },
        Did_you_take_last_year_s_2020_survey2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`No`,`Unsure`,`Yes`],
                },
                title: {
                  text: "Did you take last year's 2020 survey?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [825,201,163]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Subreddit_activity2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`Active commenter`,`Active poster`,`Active poster & commenter`,`Discord/Chat only`,`Lurker`],
                },
                title: {
                  text: "Subreddit activity?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [170,8,156,10,1159]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_old_are_you__years_2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '12',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`5`,`12`,`15`,`16`,`17`,`18`,`19`,`20`,`21`,`22`,`23`,`24`,`25`,`26`,`27`,`28`,`29`,`30`,`31`,`32`,`33`,`34`,`35`,`36`,`37`,`38`,`39`,`40`,`41`,`42`,`43`,`44`,`45`,`46`,`47`,`48`,`49`,`50`,`51`,`52`,`53`,`54`,`55`,`56`,`57`,`58`,`59`,`60`,`61`,`62`,`63`,`64`,`65`,`66`,`70`,`73`,`96`,`100`],
                },
                title: {
                  text: "How old are you? (years)"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1,1,1,2,1,2,2,10,13,25,29,48,60,52,67,63,76,70,60,83,63,57,70,65,72,53,53,38,49,31,34,37,34,26,9,11,18,9,9,11,17,11,11,5,8,5,3,6,2,3,2,4,2,3,1,1,1,1,1,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Height2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '12',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`4' 5" or lower (135cm)`,`4' 6" (137 cm)`,`4' 7" (140 cm)`,`4' 9" (144 cm)`,`4' 10" (147 cm)`,`4' 11" (150 cm)`,`5' (152 cm)`,`5' 1" (155 cm)`,`5' 2" (157 cm)`,`5' 3" (160 cm)`,`5' 4" (162 cm)`,`5' 5" (165 cm)`,`5' 6" (168 cm)`,`5' 7" (170 cm)`,`5' 8" (173 cm)`,`5' 9" (175 cm)`,`5' 10" (178 cm)`,`5' 11" (180 cm)`,`6' (183 cm)`,`6' 1" (185 cm)`,`6' 2" (188 cm)`,`6' 3" (190 cm)`,`6' 4" (193 cm)`,`6' 5" (196 cm)`,`6' 6" (198 cm)`,`6' 7" (201 cm)`,`6' 8" (203 cm)`,`6' 9" (206 cm)`,`7' or higher (213 cm)`],
                },
                title: {
                  text: "Height?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [4,1,1,2,3,6,22,25,40,82,71,68,98,116,103,110,138,150,176,104,86,48,17,12,7,4,1,1,2]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Gender_identity2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`Female`,`Female (Trans)`,`Male`,`Male (Trans)`,`Non-binary`],
                },
                title: {
                  text: "Gender identity"
                },
                series: [
                  {
                    name: 'Count',
                    data: [492,13,932,17,44]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Sexual_Orientation2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`Asexual`,`Bisexual`,`Cheesesexual`,`Demisexual `,`Gay`,`Heteroflexible `,`I am a literal sex God.`,`I put my dick where I want. `,`I’ll fuck anything that walk`,`Idk`,`Lesbian`,`Mainly into pussy and female ass (like 99.99%) but this one time when I was 15 I sucked dick in a Bush and really enjoyed it if I end up being comfortable enough to invite a guy into the bedroom as per one of my fiancées fantasies I&#039;d probably chow the fuck down on it. So basically I&#039;m 100percent straight i just really enjoyed sucking dick in a Bush that one timr`,`No label/identity `,`Other`,`Pansexual`,`Straight`,`Submissive `,`unlabeled`,`Whatever`],
                },
                title: {
                  text: "Sexual Orientation"
                },
                series: [
                  {
                    name: 'Count',
                    data: [20,265,1,1,86,1,2,1,1,1,1,1,1,2,62,1049,1,1,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Which_country_do_you_live_in2021: {
                          chartOptions: {
                            type: "map",
                            mapChart: "mapChart",
                            class: "map",
                            size: "6",
                            chart: {
                              map: "myMapName"
                            },
                            title: {
                              text: "Which country do you live in?"
                            },
                            subtitle: {
                              text:
                                ''
                            },
                            mapNavigation: {
                              enabled: true,
                              buttonOptions: {
                                alignTo: "spacingBox"
                              }
                            },
                            colorAxis: {
                              min: 0
                            },
                            series: [
                              {
                                name: "Count",
                                states: {
                                  hover: {
                                    color: "#BADA55"
                                  }
                                },
                                dataLabels: {
                                  enabled: true,
                                  format: "{point.name}"
                                },
                                allAreas: false,
                                data: [ [`af`,2],[`ar`,1],[`am`,1],[`au`,34],[`at`,6],[`bs`,1],[`be`,7],[`br`,6],[`bg`,1],[`ca`,123],[`td`,1],[`cl`,1],[`cn`,1],[`co`,1],[`cr`,2],[`cy`,1],[`cz`,2],[`dk`,6],[`ec`,1],[`ee`,3],[`fi`,12],[`fr`,6],[`de`,34],[`gr`,1],[`hu`,2],[`in`,3],[`ie`,12],[`il`,1],[`it`,3],[`jp`,1],[`kz`,1],[`ke`,1],[`lv`,1],[`lt`,3],[`lu`,1],[`mt`,1],[`mx`,4],[`nl`,11],[`nz`,10],[`ne`,1],[`mk`,1],[`no`,7],[`ps`,1],[`pl`,5],[`pt`,1],[`ro`,2],[`ru`,3],[`sa`,1],[`rs`,1],[`sg`,1],[`sk`,1],[`za`,2],[`kr`,1],[`es`,3],[`se`,12],[`ch`,1],[`th`,3],[`tr`,1],[`ug`,2],[`gb`,81],[`us`,1055],[`ye`,1]]
                              }
                            ]
                          }
                        },
        If_you_re_in_the_USA_or_Canada__which_state_or_province_are_you_located_in2021: { 
            chartOptions: {
            type: "map",
            mapChart: "mapChart",
            class: "map",
            size: "6",
            chart: {
                map: "NaCan"
            },
            title: {
                text: "If you're in the USA or Canada, which state or province are you located in?"
            },
            subtitle: {
                text:
                ""
            },
            mapNavigation: {
                enabled: true,
                buttonOptions: {
                alignTo: "spacingBox"
                }
            },
            colorAxis: {
                min: 0
            },
            series: [
                {
                name: "Count",
                states: {
                    hover: {
                    color: "#BADA55"
                    }
                },
                dataLabels: {
                    enabled: true,
                    format: "{point.name}"
                },
                allAreas: false,
                data: [[`us-tx`,44],[`us-al`,13],[`us-ak`,9],[`ca-ab`,9],[`us-az`,24],[`us-ar`,7],[`ca-bc`,25],[`us-ca`,119],[`us-co`,29],[`us-ct`,12],[`us-de`,3],[`us-fl`,31],[`us-ga`,21],[`us-hi`,1],[`us-id`,2],[`us-il`,39],[`us-in`,23],[`us-ia`,7],[`us-ks`,10],[`us-ky`,7],[`us-la`,8],[`us-me`,5],[`ca-mb`,9],[`us-md`,18],[`us-ma`,32],[`us-mi`,34],[`us-mn`,21],[`us-ms`,1],[`us-mo`,23],[`us-mt`,2],[`us-ne`,7],[`us-nv`,8],[`us-nh`,8],[`us-nj`,26],[`us-nm`,9],[`us-ny`,58],[`ca-nl`,3],[`us-nc`,29],[`us-nd`,3],[`ca-nt`,1],[`ca-ns`,2],[`us-oh`,41],[`us-ok`,10],[`ca-on`,55],[`us-or`,17],[`us-pa`,48],[`ca-pe`,1],[`ca-qc`,12],[`us-ri`,5],[`ca-sk`,2],[`us-sc`,15],[`us-sd`,4],[`us-tn`,12],[`us-ut`,17],[`us-vt`,5],[`us-va`,23],[`us-wa`,47],[`us-dc`,1],[`us-wv`,14],[`us-wi`,23],[`us-wy`,1]]
                }
            ]
            }
        },
        Education2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '8',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`Did not graduate high school`,`High school or equivalent`,`Some college or university`,`College or university graduate`,`Some graduate school or continuing education`,`Completed graduate school or other continuing education`,`Trade school graduate`],
                },
                title: {
                  text: "Education"
                },
                series: [
                  {
                    name: 'Count',
                    data: [52,171,416,506,75,233,40]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Are_you_enrolled_as_a_student2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '4',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`No`,`Yes`,`Yes, and I work`],
                },
                title: {
                  text: "Are you enrolled as a student?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1260,103,126]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Religion2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '12',
                height: "auto",
                chart: {
                  type: 'bar',
                  scrollablePlotArea: {
                    minHeight: 2000,
                    scrollPositionX: 1
                  }
                },
                xAxis: {
                  categories: [`Atheist`,`Agnostic`,`Christianity`,`None`,`Not sure/Undecided`,`Spiritual`,`Atheist Jew`,`Buddhism`,`Other`,`Neopaganism`,`Judaism`,`Catholic`,`Hinduism`,`Wicca`,`Islam`,`Satanist`,`Luciferian Gnosticism`,`Pandeist`,`Pantheist`,`Pastafarian`,`Quaker`,`Taoism`,`The Satanic Temple`,`Unitarian Universalist`,`Asatru`,`Asetro`,`Atheistic satanism`,`Baha’i`,`Christian: JW`,`Deist`,`Gnostic`,`Juggalo`,`LaVeyan Satanist`,`Luciferain `,`Multireligious`,`Native American Church `,`Pagan`,`Raised Mormon`,`Reincarnationist`,`Satanist `,`Shamanism / Animism `,`Shinto`,`Solophist`,`Vodkastafarian`],
                },
                title: {
                  text: "Religion"
                },
                series: [
                  {
                    name: 'Count',
                    data: [460,414,238,140,65,65,16,13,9,8,7,6,6,6,3,3,2,2,2,2,2,2,2,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_many_times_have_you_been_arrested_this_year2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '4',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`0`,`1`,`2`,`3`,`4`,`5`,`9`,`10+`],
                },
                title: {
                  text: "How many times have you been arrested this year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1405,65,15,4,2,1,1,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Did_the_last_arrest_involve_alcohol2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`No`,`No, but alcohol was involved`,`Yes`],
                },
                title: {
                  text: "Did the last arrest involve alcohol?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [8,12,66]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_many_times_have_you_been_to_jail_this_year2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '4',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`0`,`1`,`2`,`3`,`8`,`9`,`10+`],
                },
                title: {
                  text: "How many times have you been to jail this year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1431,46,12,1,1,1,2]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Are_you_licensed_to_drive_currently2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No (never was)`,`No (used to be)`,`Yes`],
                },
                title: {
                  text: "Are you licensed to drive currently?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [10,188,108,1187]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        If_you_answered__no__used_to_be____was_this_DUI_related2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: `If you answered "no (used to be)", was this DUI-related?`
                },
                series: [
                  {
                    name: 'Count',
                    data: [1,44,63]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Marital_Status2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`Single`,`Committed Relationship`,`Engaged`,`Married`,`Separated`,`Divorced`],
                },
                title: {
                  text: "Marital Status"
                },
                series: [
                  {
                    name: 'Count',
                    data: [658,300,48,379,19,88]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        If_you_re_married_or_in_a_committed_relationship__is_your_partner_s_a_CA2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`They don't drink`,`They drink, but aren't an alcoholic`,`Alcoholic`,`CA`],
                },
                title: {
                  text: "If you're married or in a committed relationship, is your partner/s a CA?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [6,152,454,94,20]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Your_upbringing_was_or_your_parents_were____2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '12',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`Adopted`,`Dependent of the court`,`Homeless`,`It's complicated`,`Married`,`Never Married`,`Raised by grandparents/other family`,`Raised by single father`,`Raised by single mother`,`Separated / divorced`,`Ward of the court`],
                },
                title: {
                  text: "Your upbringing was or your parents were...."
                },
                series: [
                  {
                    name: 'Count',
                    data: [19,1,5,87,902,41,12,11,113,298,2]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        In_the_last_year__have_you_been_affected_by_houselessness2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "In the last year, have you been affected by houselessness?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [682,1408,83]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_many_children_do_you_have2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '4',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`0`,`1`,`2`,`3`,`4`,`5`,`7`,`10`],
                },
                title: {
                  text: "How many children do you have?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1156,160,114,33,19,6,1,2]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Do_you_want_to_have_a_another_child__now_or_in_the_future2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`No`,`Unsure/haven't decided`,`Yes`],
                },
                title: {
                  text: "Do you want to have a/another child, now or in the future?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [824,326,340]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        What_industry_do_you_work_in2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '12',
                height: "auto",
                chart: {
                  type: 'column',
                  scrollablePlotArea: {
                    minWidth: 2000,
                    scrollPositionX: 0
                  },
                },
                xAxis: {
                  labels: {
                    rotation: 90
                  },
                  categories: [`Accounting`,`Admin - clerical`,`Admin - legal`,`Adult Content creation`,`Agriculture `,`Agriculture/Politics`,`Arborist`,`Art/creative`,`Automotive`,`Banking`,`Bouncer`,`BT`,`Call center`,`Cannabis`,`Canning`,`Captioning`,`Childcare`,`Cleaner`,`Construction`,`Consultancy`,`Courier`,`Custodian `,`customer service remote`,`Delivery Driver`,`Design`,`Disability`,`Distribution - shipping`,`Drugs`,`E-commerce `,`Education`,`Electronics surplus`,`Engineering`,`Entertainment`,`Environment`,`Executive`,`Facilities Management`,`Finance`,`Firefighter`,`Florist`,`Gambling `,`General Business`,`General Labor`,`Government`,`Hairstylist `,`Health Care`,`Homemaker`,`Hospitality`,`Human Resources`,`Information technology`,`Installation/maintenance/repair`,`Insurance`,`Janitorial`,`Law enforcement `,`Leasing`,`Legal`,`Legally disabled`,`Management`,`Manufacturing`,`Marketing`,`Media/journalism/newspaper`,`Mental health services`,`Millitary`,`Music`,`None / Unemployed`,`Nonprofit/social services`,`Oil and Gas`,`Other`,`Personal services`,`Personal Training`,`Pharmaceutical`,`Poker`,`Politics`,`Probation`,`Public Safety`,`Publishing`,`Purchasing/procurement`,`QA`,`Real estate`,`Research`,`Restaurant/Food Service`,`Retail`,`Retired`,`Sales`,`Science`,`Security`,`Sex Work`,`Ski industry `,`Skilled Labor/Trades`,`Social work`,`Software`,`Stuff`,`Supply Chain Management`,`Telecommunications`,`Transcription`,`Transit `,`Translation`,`Transportation`,`Truck Driver`,`Veterinary Services`,`Video Games`,`Vision Care`,`Warehousing`,`Waste`],
                },
                title: {
                  text: "What industry do you work in?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [22,22,6,1,1,2,1,28,11,11,1,1,2,1,1,1,1,1,37,1,1,1,1,4,12,1,22,1,1,78,1,53,23,1,4,2,39,1,1,1,13,14,42,1,111,4,52,7,109,7,2,2,1,1,33,1,12,32,26,21,1,12,1,231,19,2,9,1,1,6,1,2,1,2,1,3,6,14,22,74,57,9,34,13,3,4,1,45,1,1,1,1,1,1,1,2,1,1,6,1,1,1,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Did_you_lose_or_gain_a_job_in_the_last_year2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`Neither (stayed employed)`,`Neither (stayed unemployed)`,`Gained a job`,`Lost a job`,`Both`],
                },
                title: {
                  text: "Did you lose or gain a job in the last year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [66,745,170,238,69,202]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        If_you_lost_it_in_the_last_year__do_you_believe_it_s_related_to_drinking2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`Definitely not`,`Probably not`,`Possibly`,`Probably`,`Definitely`],
                },
                title: {
                  text: "If you lost it in the last year, do you believe it's related to drinking?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [5,93,17,42,32,78]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Are_you_covered_by_health_insurance2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`No`,`Partial Coverage`,`Yes`],
                },
                title: {
                  text: "Are you covered by health insurance?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [218,82,1189]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_much_money__in_USD__did_you_earn_last_year2021: { 
            chartOptions: {
                main: 'Demographics',
                size: '12',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`N/A`,`$0-$10,000`,`$10,001-$20,000`,`$20,001-$30,000`,`$30,001-$40,000`,`$40,001-$50,000`,`$50,001-$60,000`,`$60,001-$70,000`,`$70,001-$80,000`,`$80,001-$90,000`,`$90,001-$100,000`,`$100,000+`,`Decline to answer`],
                },
                title: {
                  text: "How much money (in USD) did you earn last year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [90,150,137,159,145,113,123,97,65,62,50,191,108]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },        
    },
    fun: {
        How_often_do_you_shower_bathe2021: { 
            chartOptions: {
                main: 'Fun',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`Multiple times a day`,`Once a day`,`Every other day`,`Once every few days`,`Only days I work`,`Seldom`,`When there's a reason to/"as needed"`],
                },
                title: {
                  text: "How often do you shower/bathe?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [75,592,274,264,43,42,112]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_often_do_you_brush_your_teeth2021: { 
            chartOptions: {
                main: 'Fun',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`None`,`Seldom`,`Almost every day`,`1 time per day`,`2 times per day`,`3+ times per day`],
                },
                title: {
                  text: "How often do you brush your teeth?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [19,169,302,421,451,40]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_often_do_you_floss_your_teeth2021: { 
            chartOptions: {
                main: 'Fun',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`None`,`Seldom`,`A few times a week`,`Almost every day`,`Every day`,`2+ times per day`],
                },
                title: {
                  text: "How often do you floss your teeth?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [356,537,245,123,104,37]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Do_you_drink_coffee_regularly2021: { 
            chartOptions: {
                main: 'Fun',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`I don't drink coffee`,`Seldom`,`A few times a month`,`A few times a week`,`Almost every day`,`Every day`],
                },
                title: {
                  text: "Do you drink coffee regularly?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [242,140,97,175,228,520]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Do_you_have_any_pets__None_2021: { 
            chartOptions: {
                main: 'Fun',
                size: '12',
                height: "auto",
                chart: {
                  type: 'column',
                  scrollablePlotArea: {
                    minWidth: 2000,
                    scrollPositionX: 0
                  },
                },
                xAxis: {
                  categories: [`None`,`Cat/s`,`Dog/s`,`Fish`,`Chicken/s`,`Bird/s`,`Reptile/s`,`Snake/s`,`Rabbit/s`,`Turtle/s`,`Hamster/s`,`Guinea Pig/s`,`Goat/s`,`Ferret/s`,`Gerbil/s`,`Spider/s`,`Horse/s`,`Pig/s`,`Rat`,`Rats`,`Ants`,`Bees`,`Children`,`Chinchilla`,`Ducks`,`Frog`,`Gecko`,`Geese`,`Had a parrot, he flew away, had a snake, he died so I bit his head off`,`Hedgehog`,`Hermit crabs`,`Lizards`,`Opossum`,`Plants`,`Quail`,`Scorpion/s`,`Scorpions wtf?`,`Shrimp`,`Shrimps & Snails`,`Worms in worm farm`],
                },
                title: {
                  text: `Do you have any pets?`
                },
                series: [
                  {
                    name: 'Count',
                    data: [496,528,500,44,29,28,25,16,13,12,11,10,7,5,5,4,3,2,2,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Which_sports_did_you_follow_this_year__None_2021: { 
            chartOptions: {
                main: 'Fun',
                size: '12',
                height: "auto",
                chart: {
                  type: 'column',
                  scrollablePlotArea: {
                    minWidth: 2000,
                    scrollPositionX: 0
                  },
                },
                xAxis: {
                  categories: [`None`,`Football`,`Basketball`,`Baseball`,`Hockey`,`Soccer (USA)/Football (UK)`,`MMA`,`UFC`,`E-sports`,`Formula 1`,`Boxing`,`Golf`,`Auto Racing`,`Chess`,`Running`,`Weightlifting`,`Tennis`,`Skateboarding`,`Cycling`,`Cricket`,`Rugby`,`Wrestling`,`Skiing`,`Swimming`,`Surfing`,`Climbing`,`Darts`,`Snowboarding`,`Disc Golf`,`Equestrian Sports`,`Billiards`,`Moto GP`,`Volleyball`,`Lacrosse`,`Snooker`,`Karate`,`Sumo`,`Fishing`,`Hiking`,`Ice Skating`,`Poker`,`Gymnastics `,`Rollerskating`,`AFL`,`Armwrestling`,`ATV`,`Australian Football`,`Bodybuilding `,`Bowling `,`Canicross`,`CrossFit `,`Handball`,`Indycar`,`Japanese Lawn Bowling `,`Jelle's Marble Runs`,`Motocross, badminton `,`MTB`,`Mxgp , supercross`,`Orienteering`,`Rugby`,`Snowmobiling`,`Strongman`,`Summer Olympics`,`Triathlon `,`Ultimate Frisbee`,`Wheelchair basketball`,`Yoga/pilates `],
                },
                title: {
                  text: "Which sports did you follow this year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [649,367,170,169,144,111,84,78,74,61,54,52,49,33,33,31,30,28,24,22,22,19,18,18,14,13,13,13,11,11,10,10,8,7,6,5,4,3,3,3,3,2,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Do_you_consider_yourself_a_violent_person2021: { 
            chartOptions: {
                main: 'Fun',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`No`,`Yes`],
                },
                title: {
                  text: "Do you consider yourself a violent person?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1313,88]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Did_you_get_into_a_physical_fight_in_the_last_year2021: { 
            chartOptions: {
                main: 'Fun',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`No`,`Yes`],
                },
                title: {
                  text: "Did you get into a physical fight in the last year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1245,156]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Do_you_own_a_gun_multiple_guns2021: { 
            chartOptions: {
                main: 'Fun',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`No`,`Yes`],
                },
                title: {
                  text: "Do you own a gun/multiple guns?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1086,315]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Have_you_shot_it_them_in_the_last_year2021: { 
            chartOptions: {
                main: 'Fun',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Have you shot it/them in the last year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1,152,155]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_many_languages_do_you_speak_fluently2021: { 
            chartOptions: {
                main: 'Fun',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`,`10+`],
                },
                title: {
                  text: "How many languages do you speak fluently?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1072,261,51,13,2,2]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Here_we_are_again____poop__What_s_your_normal_consistency2021: { 
            chartOptions: {
                main: 'Fun',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`Type 1`,`Type 2`,`Type 3`,`Type 4`,`Type 5`,`Type 6`,`Type 7`],
                },
                title: {
                  text: "Here we are again... poop. What's your normal consistency?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [38,55,180,518,171,287,99]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        What_type_of_device_do_you_use_the_MOST_for_surfing_the_internet2021: { 
            chartOptions: {
                main: 'Fun',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`Desktop`,`Gaming console`,`Laptop`,`Phone`,`Smart TV`,`Tablet`],
                },
                title: {
                  text: "What type of device do you use the MOST for surfing the internet?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [152,4,203,997,2,43]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Do_you_wear_glasses_or_contact_lenses2021: { 
            chartOptions: {
                main: 'Fun',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`Contacts`,`Glasses`,`Both`,`Neither`],
                },
                title: {
                  text: "Do you wear glasses or contact lenses?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [89,528,175,609]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        
    },
    drinking: {
        Do_you_consider_yourself_an_alcoholic2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`No`,`Possibly`,`Yes, between crippling and high functioning`,`Yes, crippling alcoholism`,`Yes, high functioning`,`Yes, in recovery`],
                },
                title: {
                  text: "Do you consider yourself an alcoholic?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [60,136,363,118,360,148]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Do_you_consider_yourself_a_binge_drinker_or_maintenance_drinker2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`Binge Drinker`,`Both`,`Maintenance Drinker`,`Neither`,`Currently Sober`,`Other`,`Anxiety drinker`,`It depends`,`Sometimes binge drink, but not an alcoholic`,`Occasional, "as needed", mostly as a way to fall asleep in five minutes (insomnia is a bitch)`,`Not sure`,`i dont drink much`,`I have strict rules`,`Weekender`],
                },
                title: {
                  text: "Do you consider yourself a binge drinker or maintenance drinker?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [461,429,192,74,5,2,1,1,1,1,1,1,1,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        At_what_age_did_you_have_your_first_drink2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  max: 53,
                  categories: [`1`,`2`,`3`,`4`,`5`,`6`,`7`,`8`,`9`,`10`,`11`,`12`,`13`,`14`,`15`,`16`,`17`,`18`,`19`,`20`,`21`,`22`,`23`,`24`,`26`,`30`],
                },
                title: {
                  text: "At what age did you have your first drink?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [2,6,8,7,9,12,8,16,10,28,36,123,126,186,174,145,84,103,37,29,24,2,4,2,3,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        At_what_age_did_you_start_drinking_reulgarly2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  max: 53,
                  categories: [`1`,`3`,`5`,`6`,`9`,`10`,`12`,`13`,`14`,`15`,`16`,`17`,`18`,`19`,`20`,`21`,`22`,`23`,`24`,`25`,`26`,`27`,`28`,`29`,`30`,`31`,`32`,`33`,`34`,`35`,`37`,`38`,`39`,`40`,`41`,`42`,`45`,`49`],
                },
                title: {
                  text: "At what age did you start drinking reulgarly?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [3,1,1,1,2,1,7,20,42,72,112,97,211,115,86,153,67,33,28,25,15,17,10,5,18,2,3,4,6,4,2,3,2,2,2,1,1,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        At_what_age_did_you_become_physically_dependent_on_alcohol2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  max: 53,
                  categories: [`1`,`2`,`3`,`5`,`8`,`11`,`12`,`14`,`15`,`16`,`17`,`18`,`19`,`20`,`21`,`22`,`23`,`24`,`25`,`26`,`27`,`28`,`29`,`30`,`31`,`32`,`33`,`34`,`35`,`36`,`37`,`38`,`39`,`40`,`41`,`42`,`43`,`44`,`45`,`46`,`47`,`48`,`49`,`50`,`52`,`53`],
                },
                title: {
                  text: "At what age did you become physically dependent on alcohol?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [13,1,2,1,1,1,1,2,8,10,16,58,55,66,107,88,76,76,82,52,56,51,13,65,13,24,20,12,25,14,13,5,4,11,3,8,2,1,3,2,2,4,2,8,1,2]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        When_maintaining__approximately_how_many_drinks_do_you_have_per_day_2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`0`,`1`,`2`,`3`,`4`,`5`,`6`,`7`,`8`,`9`,`10`,`11`,`12`,`13`,`14`,`15`,`16`,`17`,`18`,`20`,`22`,`23`,`24`,`25`,`28`,`30`,`31`,`33`,`35`,`40`,`50`,`55`,`60`,`65`,`70`,`100`],
                },
                title: {
                  text: "When maintaining, approximately how many drinks do you have per day?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [149,11,33,61,87,76,130,52,108,25,120,7,84,14,13,69,10,4,10,26,4,3,3,11,2,6,1,2,3,2,1,1,1,1,1,3]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        When_binging__approximately_how_many_drinks_do_you_have_per_day__2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`0`,`1`,`2`,`3`,`4`,`5`,`6`,`7`,`8`,`9`,`10`,`11`,`12`,`13`,`14`,`15`,`16`,`17`,`18`,`19`,`20`,`21`,`22`,`23`,`24`,`25`,`26`,`27`,`28`,`29`,`30`,`32`,`33`,`34`,`35`,`36`,`37`,`38`,`39`,`40`,`41`,`42`,`43`,`45`,`48`,`50`,`56`,`65`,`70`,`100`],
                },
                title: {
                  text: "When binging, approximately how many drinks do you have per day?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [36,3,3,3,16,15,34,25,63,25,123,14,109,24,42,145,60,24,46,1,131,8,21,6,31,38,3,3,6,1,52,1,3,1,17,2,1,1,1,12,1,1,1,2,3,2,1,1,1,5]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_much_money__in_USD__do_you_spend_on_alcohol_per_week2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '10',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`0`,`1`,`3`,`5`,`7`,`8`,`10`,`12`,`13`,`15`,`17`,`20`,`21`,`22`,`25`,`26`,`28`,`30`,`32`,`33`,`34`,`35`,`38`,`39`,`40`,`45`,`48`,`50`,`52`,`54`,`55`,`56`,`60`,`65`,`66`,`70`,`75`,`80`,`85`,`90`,`93`,`94`,`95`,`96`,`98`,`100`,`104`,`105`,`110`,`111`,`112`,`115`,`120`,`125`,`130`,`135`,`140`,`142`,`150`,`160`,`175`,`180`,`189`,`200`,`210`,`220`,`240`,`245`,`250`,`255`,`280`,`300`,`325`,`350`,`400`,`453`,`500`,`550`,`666`,`700`,`725`,`900`,`999`],
                },
                title: {
                  text: "How much money (in USD) do you spend on alcohol per week?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [80,2,2,3,1,1,22,3,1,11,1,48,3,1,17,1,1,57,1,1,1,16,1,1,64,11,2,127,2,2,6,1,61,2,1,53,27,45,6,8,1,1,1,1,1,164,1,2,2,1,1,3,27,5,6,2,18,1,67,6,5,3,1,42,1,2,1,1,11,1,1,20,1,3,6,1,3,1,1,1,1,1,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        On_average__how_many_days_per_week_do_you_drink2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '2',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`0`,`1`,`2`,`3`,`4`,`5`,`6`,`7`],
                },
                title: {
                  text: "On average, how many days per week do you drink?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [88,33,62,95,111,137,117,542]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_often_do_you_drink_at_work2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`None`,`A few days a year`,`A few days a month`,`A few days a week`,`Almost Every Day`,`Every Day`],
                },
                title: {
                  text: "How often do you drink at work?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [63,466,125,97,82,74,79]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_often_do_you_drink_before_work2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`None`,`A few days a year`,`A few days a month`,`A few days a week`,`Almost Every Day`,`Every Day`],
                },
                title: {
                  text: "How often do you drink before work?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [51,533,110,80,75,57,78]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_many_times_have_you_called_out_of_work_due_to_alcohol_in_the_last_year2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`0`,`1-3`,`4-6`,`7-10`,`11+`,`N/A`],
                },
                title: {
                  text: "How many times have you called out of work due to alcohol in the last year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [333,289,157,66,64,66]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Is_drinking_at_your_work_socially_acceptable2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Is drinking at your work socially acceptable?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [71,700,213]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_often_do_you_blackout2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`Never`,`Rarely`,`On occasion`,`Most times`,`Always`],
                },
                title: {
                  text: "How often do you blackout?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [31,109,291,416,269,68]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_often_does_a_blackout_result_in_regret2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`Never`,`Not often`,`Occasionally`,`Very often`,`Every time`],
                },
                title: {
                  text: "How often does a blackout result in regret?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [67,69,170,244,310,262]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Do_you_have_a_drinking_buddy_that_can_keep_up_with_your_drinking2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Do you have a drinking buddy that can keep up with your drinking?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [77,630,438]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Do_your_friends_know_about_your_drinking_habits2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Do your friends know about your drinking habits?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [76,365,707]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Does_your_family_know_about_your_drinking_habits2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Does your family know about your drinking habits?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [43,535,563]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_many_DUIs_have_you_had_total2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`0`,`1`,`2`,`3`,`4`,`5`,`9`,`14`,`23`,`93`],
                },
                title: {
                  text: "How many DUIs have you had total?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [949,164,41,16,6,2,1,1,1,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Did_you_get_a_DUI_in_the_last_year2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A (Didn't drink, didn't drive, etc)`,`No`,`Yes`],
                },
                title: {
                  text: "Did you get a DUI in the last year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [13,181,33]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        What_type_of_alcohol_do_you_currently_prefer2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '12',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`Beer`,`Bourbon`,`Brandy`,`Cider`,`Gin`,`Malt liquor`,`Rum`,`Tequila`,`Vodka`,`Whiskey`,`Wine`],
                },
                title: {
                  text: "What type of alcohol do you currently prefer?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [332,49,2,20,43,30,47,18,310,127,161]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        In_the_last_year__did_you_use_an_atypical_source_of_alcohol_such_as_mouthwash__vanilla_extract__cooking_wine__etc__to_fight_off_withdrawals2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "In the last year, did you use an atypical source of alcohol such as mouthwash, vanilla extract, cooking wine, etc. to fight off withdrawals?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [32,1001,152]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Is_alcohol_your_first_choice_of_drug2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Is alcohol your first choice of drug?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [10,218,957]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_often_do_you_go_to_the_bar2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`I don't`,`A few times a year`,`A few times a month`,`A few times a week`,`Every day`],
                },
                title: {
                  text: "How often do you go to the bar?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [433,332,273,134,13]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Do_you_believe_alcohol_has_made_you_more_reclusive2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`No, I don't believe alcohol has affected this`,`Yes, I'm less reclusive due to alcohol`,`Yes, I'm more reclusive due to alcohol`],
                },
                title: {
                  text: "Do you believe alcohol has made you more reclusive?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [374,97,712]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_often_do_you_puke_from_drinking__or_associated_with_it_2021: { 
            chartOptions: {
                main: 'Drinking',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`Never`,`A few times a year`,`A few times a month`,`A few times a week`,`Every day`],
                },
                title: {
                  text: "How often do you puke from drinking? (or associated with it)"
                },
                series: [
                  {
                    name: 'Count',
                    data: [43,269,480,242,125,26]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        
    },
    medical: {
        Have_you_contracted_a_lasting_illness_as_a_result_of_your_drinking2021: { 
            chartOptions: {
                main: 'Medical',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Have you contracted a lasting illness as a result of your drinking?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1084,906,183]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Do_you_take_anything_to_help_liver_function__Milk_thistle__B_vitamins__etc_2021: { 
            chartOptions: {
                main: 'Medical',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Do you take anything to help liver function? (Milk thistle, B vitamins, etc)"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1084,575,514]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        When_was_the_last_time_you_went_to_a_scheduled_medical_appointment__alcohol_related_or_otherwise_2021: { 
            chartOptions: {
                main: 'Medical',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`Less than a month`,`A month to three months`,`Three months to six months`,`Six months to a year`,`A year or longer`],
                },
                title: {
                  text: "When was the last time you went to a scheduled medical appointment (alcohol related or otherwise)"
                },
                series: [
                  {
                    name: 'Count',
                    data: [223,209,133,147,377]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_many_alcohol_related_hospitalizations_have_you_had_in_the_last_year2021: { 
            chartOptions: {
                main: 'Medical',
                size: '4',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`0`,`1`,`2`,`3`,`4`,`5`,`6`,`7`,`8`,`9`,`10+`],
                },
                title: {
                  text: "How many alcohol-related hospitalizations have you had in the last year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [859,125,51,23,11,3,4,1,1,4,7]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Have_you_served_in_the_armed_forces_in_your_respective_country2021: { 
            chartOptions: {
                main: 'Medical',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Have you served in the armed forces in your respective country?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1084,1029,60]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Has_it_contributed_to_your_drinking2021: { 
            chartOptions: {
                main: 'Medical',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Has it contributed to your drinking?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [2116,24,33]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_much_has_depression_affected_you2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "How much has depression affected you?"
                },
                subtitle: {
                    text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                },
                series: [
                  {
                    name: 'Count',
                    data: [38,100,250,345,354]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
       How_much_do_you_believe_drinking_has_affected_this_Depression2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "How much do you believe drinking has affected this?"
                },
                subtitle: {
                    text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                },
                series: [
                  {
                    name: 'Count',
                    data: [90,146,260,284,307]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_much_has_general_anxiety_affected_you2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "How much has general anxiety affected you?"
                },
                subtitle: {
                    text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                },
                series: [
                  {
                    name: 'Count',
                    data: [52,87,189,353,406]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_much_do_you_believe_drinking_has_affected_this_general_anxiety2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "How much do you believe drinking has affected this?"
                },
                subtitle: {
                    text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                },
                series: [
                  {
                    name: 'Count',
                    data: [126,121,220,266,354]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_much_has_social_anxiety_affected_you2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "How much has social anxiety affected you?"
                },
                subtitle: {
                    text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                },
                series: [
                  {
                    name: 'Count',
                    data: [122,172,203,257,333]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_much_do_you_believe_drinking_has_affected_this_social_anxiety2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "How much do you believe drinking has affected this?"
                },
                subtitle: {
                    text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                },
                series: [
                  {
                    name: 'Count',
                    data: [320,199,196,166,206]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Does_being_a_CA_affect_your_personal_relationships_2021: { 
            chartOptions: {
                main: 'Medical',
                size: '4',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "Does being a CA affect your personal relationships?"
                },
                subtitle: {
                    text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                },
                series: [
                  {
                    name: 'Count',
                    data: [156,160,245,231,295]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Does_being_a_CA_affect_your_romantic_relationships2021: { 
            chartOptions: {
                main: 'Medical',
                size: '4',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "Does being a CA affect your romantic relationships?"
                },
                subtitle: {
                    text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                },
                series: [
                  {
                    name: 'Count',
                    data: [172,124,205,217,369]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Does_being_a_CA_affect_your_social_life2021: { 
            chartOptions: {
                main: 'Medical',
                size: '4',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "Does being a CA affect your social life?"
                },
                subtitle: {
                    text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                },
                series: [
                  {
                    name: 'Count',
                    data: [183,189,212,196,307]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        What_medical_disorders_have_you_been_diagnosed_with_from_a_doctor2021: { 
            chartOptions: {
                main: 'Medical',
                size: '12',
                height: "auto",
                chart: {
                    type: 'bar',
                    scrollablePlotArea: {
                        minHeight: 6000,
                        scrollPositionX: 1
                    },
                },
                xAxis: {
                    categories: [`Depression`,`Anxiety`,`Anxiety - Generalized`,`ADHD`,`High Blood Pressure`,`PTSD`,`Bipolar Disorder`,`Major Depressive Disorder`,`Borderline Personality Disorder`,`Fatty Liver Disease`,`Hypertension`,`Alcohol Use Disorder`,`Ocd`,`Anxiety - Social`,`Asthma`,`Panic Attack Disorder`,`Autism Spectrum Disorder`,`C-PTSD`,`Pancreatitis`,`Insomnia`,`Gerd`,`Hypothyroidism`,`Obesity`,`Bipolar II`,`Gad`,`IBS`,`Ibs`,`High Cholesterol`,`ADD`,`Bulimia Nervosa`,`Epilepsy`,`Alcoholism`,`Cirrhosis`,`Gout`,`Polycystic ovary syndrome`,`Anemia`,`Anorexia`,`Clinical Depression`,`Gastritis`,`Agoraphobia`,`Bipolar I`,`Diabetes`,`Schizophrenia`,`Sleep Apnea`,`Substance Abuse Disorder`,`Alcohol Dependency`,`Fibromyalgia`,`Alcoholic Hepatitis`,`Celiac Disease`,`Depression - Severe`,`Endometriosis`,`Psychosis`,`Substance Use Disorder Disorder`,`Alcohol Abuse Disorder`,`Anxiety - Severe`,`Arthritis`,`Chronic Pain`,`Eczema`,`Hashimoto’s Thyroid Disease`,`High Triglycerides`,`Rheumatoid Arthritis`,`Seizures`,`Ulcers`,`Acute Pancreatitis`,`Addiction`,`ADHD-C`,`Alcoholic Gastritis`,`Allergies`,`Avoidant Personality Disorder`,`Charcot Marie Tooth Disease`,`Chronic Depression`,`Chronic Fatigue Syndrome`,`Chronic fatigue syndrome`,`Chronic Kidney Disease`,`Chronic Migraine`,`COPD`,`Dissociative Identity Disorder`,`Eating Disorder`,`Ehlers Danlos Syndrome`,`Elevated Liver Enzymes`,`Esophageal Ulcer`,`Gall Stones`,`Gilbert’s Syndrome`,`Health Anxiety`,`Heart Palpitations`,`Hepatitis C`,`Iron Deficiency`,`Jaundice`,`Low Blood Pressure`,`Low Vitamin D`,`Lyme Disease`,`Malnutrition`,`Migraines`,`Multiple Sclerosis`,`Neuropathy`,`Ovarian Cysts`,`Persistent Depressive Disorder`,`Post-Acute Withdrawal Syndrome`,`Premenstrual dysphoric disorder`,`Psoriasis`,`Schizoaffective Disorder`,`Scoliosis`,`Stomach Ulcerss`,`Tinnitus`,`Acid Reflux`,`Acrophobia`,`Acute Anxiety Disorder`,`Adjustment Disorder`,`Adult ADHD`,`Afib`,`Alc Hepatitis`,`Alcohol Binge Disorder`,`Alcohol Use Disorder - Severe`,`Alcohol Use Disorder Uncomplicated`,`Alcoholic Fatty Liver`,`Alcoholic Neuropathy`,`Amblyopia`,`Anal Cancer`,`Anal Fissures`,`Anciety`,`Androgenetic Alopecia`,`Antisocial Disorder`,`Antisocial Personality Disorder`,`Anxiety-induced Seizures`,`Asma`,`Asthma And Allergies`,`Astigmatism`,`Attention Deficit Disorder, Inattentive Type`,`Autoimmune Disorder`,`Bad Back From Crashing`,`Bad Circulation`,`Barret’s Esophagus`,`Being A Fat Fuck Come On Man`,`Benign paroxysmal positional vertigo`,`Binge Eating Disorder`,`Bipolar Disorder - Moderate`,`Bipolar I/II`,`Blood Clot`,`Bopolar`,`Breast Cancer`,`Cancer`,`Cardiomegaly`,`Carpal Tunnel-both Hands`,`Cavities`,`Cerebral Palsy`,`Chrohns`,`Chronic Acute Pancreatitis`,`Chronic Bronchitis`,`Chronic Illness Unspecified`,`Chronic Kidney Pain`,`Chronic Pancreatitis`,`Chronic Regional Pain Syndrome (crps/rsd)`,`Chronic Tendinitis`,`Club Foot`,`Cognitive Dissonance`,`Constructive Sleep Apnea`,`Crohn’s Disease`,`Crohns`,`Cyclic Vomiting Disorder`,`Cyclothymia`,`De Quervain’s Tenosynovitis`,`Degenerative Arthritis In My Spine`,`Degenerative Disc Disease`,`Dependent Personality Disorder`,`Depersonalization Disorder`,`Depersonalization-derealization Disorder`,`Depression - Severe (Chronic)`,`Depression (resolved In Recovery)`,`Dermatitis`,`Diabetes With Complications`,`Disthymia`,`Diverticulitis`,`Dysmenorrhea`,`Dyspepsia`,`Dysphagia`,`Dysthymia`,`Early Stage Kidney Failure`,`Eating Disorder Not Otherwise Specified`,`Ed`,`Edema`,`Ednos`,`Elevated Liver Function`,`Emotionally Retarded`,`Erectile Dysfunction`,`Erosive Esophagitis`,`Esophageal Spasms`,`Esophagitis`,`Essential Tremor`,`Extradural Haematoma`,`Fibroids`,`Fibrosis`,`Fractured Skull`,`Fucked Up Gums`,`Gastricitus`,`Gastro-esophaheal Reflux Disease With Esophogitis`,`Gastroparesis`,`Generalized Epilepsy`,`Glaucoma`,`Graves Disease`,`Hearing Loss`,`Heart Arrhythmia`,`Heart Disease`,`Heart Disease - Obstruction In Mitral Valve`,`Heart Disease Fibrillation`,`Heart Transplant`,`Hemiplegic Migraine`,`Hemophilia`,`Hemorrhoids`,`Hepatitis`,`Hernia`,`Herniated Discs`,`Herpes`,`Hidradenitis Supurativa`,`High Aces Score`,`High Anxiety`,`High Liver Enzymes`,`Hyper Tension`,`Hyperactivity Disorder`,`Hyperlipidemia`,`Hypoglycemia`,`Hypothiroidism`,`Idiopathic Hypersomnia`,`Iron Overload`,`Irregular Heartbeat`,`Irritable Bowel`,`Irritated Liver`,`Ischemic Stroke`,`Itp`,`Joint Pain`,`Juggalo Flu`,`Learning Disability (un Categorized)`,`Left ventricular hypertrophy`,`Leukemia`,`Liberalism`,`Liver Disease`,`Lordosis`,`Low Platelet Count`,`Malnourishment`,`May-thurner Syndrome/blood Clots`,`Meinere’s Disease`,`Migraine`,`Morbid Obesity`,`Muscular Dystrophy`,`Myopia`,`Myotonic Muscular Dystrophy`,`Narcolepsy`,`Night Vision`,`Nonsuicidal self-injury disorder`,`Obsessive Compulsive Disorder`,`Occipital Neuralgia`,`Opiate Use Disorder`,`Oral Allergy Syndrome`,`Osgood-schlatters`,`Osteoarthritis`,`Panic/gad`,`Peripheral Neuropathy`,`Personality Disorder`,`Plantar Fasciitis`,`Postural orthostatic tachycardia syndrome`,`Premature Ventricular Contractions)`,`Psoriasiatic Arthritis`,`PTSD-C`,`Raynaud’s Disease`,`Reflux`,`Ruined My Ankles From Riding Dirt Bikes And Motorcycles`,`Sarcoidosis`,`Seasonal affective disorder`,`Sjögrens Syndrome`,`Skin Psoriosis`,`Sleep Disorder`,`Social Avoidant Personality Disorder`,`Speech Impediment`,`Spinal Degeneration`,`Spinal Fusion`,`Stomach Ulcers`,`Substance Abuse, Intermittent`,`Substance Use Disorder`,`Tachycardia`,`Telogen Effluvium`,`Thiamine Deficiency`,`TMJ`,`Tobacco Use Disorder`,`Torn Stomach Lining`,`Traumatic Brain Injury`,`Treatment Resistant Major Depression`,`Trichotillomania`,`Type 1 Diabetes`,`Type 2 Diabetes`,`Type 2 Respiratory Failure`,`Unspecified Autoimmune Disease`,`Uterine Fibriods`,`Uti`,`Varices`,`Varicose Veins`,`Vasovagal Syncope`,`Venom Allergy`,`Visual Snow`,`Vitamin B Deficiency`,`Vitamin D3 Deficiency`,`Wernicke-korsakoff Syndrome`,`Withdrawal Seizure`],
                },
                yAxis: {

                },
                title: {
                  text: "What medical disorders have you been diagnosed with from a doctor?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [233,173,78,66,48,45,44,43,33,30,27,24,24,23,23,23,19,18,17,16,14,13,12,11,11,11,11,10,9,9,9,8,8,8,8,7,7,7,7,6,6,6,6,6,6,5,5,4,4,4,4,4,4,3,3,3,3,3,3,3,3,3,3,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Do_you_receive_medication_for_any_disorders_listed_above2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Do you receive medication for any disorders listed above?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1661,160,352]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Has_drinking_worsened_the_symptoms_of_any_of_the_disorders_above2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`No`,`Not sure`,`Yes`],
                },
                title: {
                  text: "Has drinking worsened the symptoms of any of the disorders above?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [46,108,396]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Have_you_ever_self_harmed__besides_drugs_alcohol_2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Have you ever self harmed (besides drugs/alcohol)?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1086,570,517]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        In_the_last_year2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "In the last year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1660,295,218]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Do_you_receive_regular_psychiatric_psychological_care_or_therapy2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Do you receive regular psychiatric/psychological care or therapy?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1086,790,297]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Does_your_family_have_a_history_of_alcoholism2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Does your family have a history of alcoholism?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1086,232,855]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_many_hours_of_sleep_do_you_usually_get_on_average2021: { 
            chartOptions: {
                main: 'Medical',
                size: '12',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`,`6`,`7`,`8`,`9`,`10`,`11`,`12`,`13`,`14`,`15`,`23`,`24`],
                },
                title: {
                  text: "How many hours of sleep do you usually get on average?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [2,3,12,69,166,313,249,171,41,39,4,12,2,1,1,1,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Have_you_had_a_night_terror_in_the_last_year_2021: { 
            chartOptions: {
                main: 'Medical',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Have you had a night terror in the last year? "
                },
                series: [
                  {
                    name: 'Count',
                    data: [1086,512,575]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Do_you_regularly_piss_the_bed_from_drinking2021: { 
            chartOptions: {
                main: 'Medical',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`No`,`No, irregularly`,`Yes`],
                },
                title: {
                  text: "Do you regularly piss the bed from drinking?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [878,148,46]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Have_your_family_friends_staged_an_intervention_for_you_in_the_last_year2021: { 
            chartOptions: {
                main: 'Medical',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Have your family/friends staged an intervention for you in the last year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1086,987,100]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_many_times_have_you_been_to_detox_in_the_last_year2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`0`,`1`,`2`,`3`,`4`,`5`,`6`,`8`,`9`,`10+`],
                },
                title: {
                  text: "How many times have you been to detox in the last year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [177,72,26,16,4,5,1,2,2,3]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_many_times_have_you_been_to_detox_over_the_course_of_your_life2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                  type: 'column'
                },
                xAxis: {
                  categories: [`0`,`1`,`2`,`3`,`4`,`5`,`6`,`7`,`8`,`9`,`10`,`11`,`12`,`15`,`16`,`20`,`26`,`27`,`28`,`30`,`55`,`77`],
                },
                title: {
                  text: "How many times have you been to detox over the course of your life?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [761,125,67,28,20,19,11,9,6,1,7,1,3,7,1,2,1,1,1,1,1,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Have_you_tried_to_stop_drinking_in_the_last_year2021: { 
            chartOptions: {
                main: 'Medical',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`,`Yes, it was a forced decision (family, court, etc)`],
                },
                title: {
                  text: "Have you tried to stop drinking in the last year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [39,326,669,53]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_many_times_have_you_tried_to_stop_drinking_in_the_last_year2021: { 
            chartOptions: {
                main: 'Medical',
                size: '4',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`0`,`1`,`2`,`3`,`4`,`5`,`6`,`7`,`8`,`9`,`10+`,`Other`],
                },
                title: {
                  text: "How many times have you tried to stop drinking in the last year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [11,144,158,105,79,45,32,10,4,4,126,4]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        If_you_have_tried_to_stop_in_the_last_year__how_long_was_the_longest_period_it_was_effective2021: { 
            chartOptions: {
                main: 'Medical',
                size: '4',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`Up to a day`,`A day to a week`,`A week to a month`,`A month to 3 months`,`3 months to 6 months`,`6 months to a year`],
                },
                title: {
                  text: "If you have tried to stop in the last year, how long was the longest period it was effective?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [5,38,174,266,122,68,48]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Of_the_time_s_you_ve_tried_to_stop__which_programs_methods_did_you_use2021: { 
            chartOptions: {
                main: 'Medical',
                size: '12',
                height: "auto",
                chart: {
                    type: 'bar',
                    scrollablePlotArea: {
                        minHeight: 1500,
                        scrollPositionX: 1
                    },
                },
                xAxis: {
                  categories: [`None`,`Cold Turkey`,`Tapering`,`/r/CA`,`/r/Dryalcoholics`,`/r/Stopdrinking`,`AA/12 Step`,`Moderation Management`,`Naltrexone/Vivitrol`,`Inpatient/Outpatient Rehab`,`Group Therapy`,`SMART`,`Recovery Support Services`,`Hotline/s`,`Antabuse`,`Campral`,`SLE (Sober Living Environment)`,`Court Ordered Rehabilitation`,`Kratom`,`HARMS`,`Individual Therapy`,`Weed`,`App`,`Ativan `,`Baclofen`,`Benzos baby`,`CBT`,`Ceremony`,`Equine Therapy`,`Family `,`Fuckin doin other stuff `,`Harm reduction, reading quit lit, podcasts, individual therapy`,`Ketogenic diet`,`Pregnancy`,`Satanic Temple Sober Faction`,`Sober & Recovery Podcasts`,`Wellbutrin `],
                },
                title: {
                  text: "Of the time/s you've tried to stop, which programs/methods did you use?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [249,320,269,182,182,153,128,106,99,80,45,38,19,17,16,14,12,11,3,2,2,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Have_you_ever_started_inpatient_treatment_2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'bar'
                },
                xAxis: {
                  categories: [`N/A`,`No`,`Yes`],
                },
                title: {
                  text: "Have you ever started inpatient treatment ?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [1086,883,204]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_many_times_have_you_been_to_inpatient_treatment_over_the_course_of_your_life2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`0`,`1`,`2`,`3`,`4`,`5`,`6`,`7`,`8`,`10+`],
                },
                title: {
                  text: "How many times have you been to inpatient treatment over the course of your life?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [2,95,45,23,15,7,5,4,1,5]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_many_times_have_you_started_inpatient_treatment_in_the_last_year2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`0`,`1`,`2`,`3`,`4`,`5`,`7`],
                },
                title: {
                  text: "How many times have you started inpatient treatment in the last year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [134,47,13,3,2,2,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        How_many_times_have_you_completed_inpatient_treatment_in_the_last_year2021: { 
            chartOptions: {
                main: 'Medical',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`0`,`1`,`2`,`3`,`4`,`5`,`6`],
                },
                title: {
                  text: "How many times have you completed inpatient treatment in the last year?"
                },
                series: [
                  {
                    name: 'Count',
                    data: [144,42,12,2,1,1,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        }
    },
    drug_Use: {
        Current_Use__Tobacco: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Tobacco"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [494,124,95,92,236]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Tobacco: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Tobacco"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [164,108,110,152,499]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Nicotine_Vaping: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Nicotine Vaping"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [685,54,36,63,201]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Nicotine_Vaping: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Nicotine Vaping"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [529,98,60,73,270]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Marijuana: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Marijuana"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [424,220,111,187,98]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Marijuana: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Marijuana"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [161,176,199,204,292]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Hash_or_other_marijuana_concentrates: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Hash or other marijuana concentrates"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [745,117,56,82,39]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Hash_or_other_marijuana_concentrates: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Hash or other marijuana concentrates"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [542,131,133,104,121]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Cocaine: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Cocaine"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [818,141,60,15,4]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Cocaine: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Cocaine"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [510,200,196,64,59]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Crack: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Crack"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [1015,14,5,1,2]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Crack: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Crack"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [926,65,21,7,10]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Light_sleeping_medication__antihistamines__diphenhydramine__etc__Melatonin__Valarian_root__etc_: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Light sleeping medication (antihistamines [diphenhydramine, etc, Melatonin, Valarian root, etc)"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [465,215,125,169,63]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Light_sleeping_medication__antihistamines__diphenhydramine__etc__Melatonin__Valarian_root__etc_: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Light sleeping medication (antihistamines [diphenhydramine, etc, Melatonin, Valarian root, etc)"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [419,216,135,170,90]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Other_sleep_medications__Hypnotic_benzos__temazepan__nitrazepan__etc___Z_drugs__Lunesta__ambien__etc___etc_: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                  type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`]
                },
                title: {
                  text: "(Current Use) Other sleep medications: Hypnotic benzos (temazepan, nitrazepan, etc), Z-drugs (Lunesta, ambien, etc), etc."
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [812,93,56,46,30]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Other_sleep_medications__Hypnotic_benzos__temazepan__nitrazepan__etc___Z_drugs__Lunesta__ambien__etc___etc_: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                  type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Other sleep medications: Hypnotic benzos (temazepan, nitrazepan, etc), Z-drugs (Lunesta, ambien, etc), etc."
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [727,126,62,63,51]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Prescription_amphetamines: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Prescription amphetamines"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [875,70,33,35,24]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Prescription_amphetamines: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Prescription amphetamines"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [697,99,87,77,69]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Methamphetamine: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Methamphetamine"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [996,24,12,2,3]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Methamphetamine: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Methamphetamine"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [865,72,47,17,28]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__MDMA_estacy: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) MDMA/estacy"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [888,104,38,5,2]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__MDMA_estacy: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) MDMA/estacy"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [613,183,164,47,22]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Mushrooms: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Mushrooms"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [787,165,70,13,2]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Mushrooms: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Mushrooms"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [562,241,176,39,12]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__LSD: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) LSD"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [881,106,45,5,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__LSD: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) LSD"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [643,189,148,38,11]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Heroin_Opium: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Heroin/Opium"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [1004,15,10,2,6]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Heroin_Opium: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Heroin/Opium"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [902,57,25,7,38]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Kratom: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Kratom"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [897,59,16,25,40]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Kratom: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Kratom"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [834,74,28,41,52]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Kava: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Kava"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [970,39,19,4,5]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Kava: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Kava"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [896,80,29,14,10]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Gabanergics__Kratom__Phenibut__etc_: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Gabanergics (Kratom, Phenibut, etc)"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [913,47,26,24,28]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Gabanergics__Kratom__Phenibut__etc_: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Gabanergics (Kratom, Phenibut, etc)"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [874,52,37,26,40]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Prescription_opiates: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Prescription opiates"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [911,82,28,7,9]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Prescription_opiates: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Prescription opiates"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [671,157,102,46,52]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Research_chemicals__2c_i__methylone__etc_: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Research chemicals (2c-i, methylone, etc)"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [993,30,6,4,2]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Research_chemicals__2c_i__methylone__etc_: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Research chemicals (2c-i, methylone, etc)"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [893,68,38,15,14]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Barbituates: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Barbituates"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [1009,23,1,0,3]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Barbituates: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Barbituates"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [968,39,18,1,2]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Anxiolytic_Benzodiazapines__Valium__Klonopin__Xanax__Librium__Ativan__etc_: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Anxiolytic Benzodiazapines (Valium, Klonopin, Xanax, Librium, Ativan, etc)"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [758,145,57,49,27]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Anxiolytic_Benzodiazapines__Valium__Klonopin__Xanax__Librium__Ativan__etc_: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Anxiolytic Benzodiazapines (Valium, Klonopin, Xanax, Librium, Ativan, etc)"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [561,185,105,95,84]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__GHB_GBL: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) GHB/GBL"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [1019,9,2,2,3]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__GHB_GBL: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) GHB/GBL"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [972,31,13,7,6]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Amyl_Nitrate_poppers: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Amyl Nitrate/poppers"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [992,20,17,3,2]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Amyl_Nitrate_poppers: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Amyl Nitrate/poppers"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [913,65,39,8,4]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Ketamine: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Ketamine"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [943,60,20,6,5]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Ketamine: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Ketamine"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [845,77,79,21,7]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__DXM_cough_syrup: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) DXM/cough syrup"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [943,66,15,5,6]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__DXM_cough_syrup: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) DXM/cough syrup"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [796,127,60,25,22]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__Nitrous_oxide: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) Nitrous oxide"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [947,48,29,6,4]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__Nitrous_oxide: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) Nitrous oxide"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [801,104,91,18,15]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Current_Use__DMT: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Current Use) DMT"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [986,35,9,4,1]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
        Past_Use__DMT: { 
            chartOptions: {
                main: 'Drug Use',
                size: '6',
                height: "auto",
                chart: {
                type: 'column'
                },
                xAxis: {
                  categories: [`1`,`2`,`3`,`4`,`5`],
                },
                title: {
                  text: "(Past Use) DMT"
                },
                subtitle: {
                    text: "1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use"
                }
                ,series: [
                  {
                    name: 'Count',
                    data: [925,71,23,5,5]
                  }
                ],
                legend: {
                  enabled: false
                }
              }
        },
    }
}]
}

